<template>
  <SogPage
    id="page"
    :title="'Willkommen bei '+title"
    flex-direction="flex-row"
  >
    <EvbActivation style="width: 300px" />
    <ClaimComponent />
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import {useAccountStore} from "@/stores/accountStore";
import {computed} from "vue";
import EvbActivation from "@/modules/Insurance/components/EvbActivation.vue";
import {useSpinner} from "@/shared/composables/SogSpinner";
import {onBeforeRouteUpdate, useRouter} from "vue-router";
import {onMounted} from "vue";
import PersonIds from "@/shared/model/PersonIds";
import ClaimComponent from "@/app/components/ClaimComponent.vue";
import SogButton from "@/shared/ui/SogButton.vue";
import {storeToRefs} from "pinia";

// eslint-disable-next-line no-undef
const _accountStore = useAccountStore();

const title = computed(() => _accountStore.installation.shortName)

const _spinner = useSpinner()
const _router = useRouter()

async function p_init() {
  _spinner.show()
  try {
    if (_accountStore.person && _accountStore.person.isLossAdjuster()) {
      await _router.push("/lossadjuster/search")
      return
    }
    if (_accountStore.person && _accountStore.person.id === PersonIds.UsNato) {
      await _router.push("/usnato")
      return
    }
  } finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
  await p_init()
});


</script>
<style scoped>
</style>
